// import 'core-js/actual';

import React, { Fragment } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
// Must evaluate before ./base/appRoutes below (~line 13): this module's module-scope
// `StoreHandler.store` read (~line 40) needs store.js to have already resolved the
// store→reducers→actions→api cycle, which appRoutes pulls in transitively via api.ts.
// Reversing this import order once hit a TDZ ReferenceError and blanked the whole app
// at boot — see api.bootOrder.test.ts.
import StoreHandler, { persistor } from "./base/store";
import { loadLocale } from "./base/userActions";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Sentry from "@sentry/react";

import { NavigationBridge, TopRoutes } from "./base/appRoutes";
import { Environment } from "./base/themes/environment";
import { Spinner } from "./base/presentation/Spinner";
import { PersistGate } from "redux-persist/integration/react";
import { LoadingView } from "./base/views/BigMessageView";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

if (!window.location.origin.includes("localhost")) {
  console.log("sentry enabled");
  Sentry.init({
    dsn: "https://da4307dde32f4a20a6f0f5473de31922@sentry.io/166528",
    environment: window.location.origin.includes("staging")
      ? "staging"
      : "production",
    integrations: [Sentry.browserTracingIntegration()],
    release: window.GIT_REV,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    ignoreErrors: [
      // CefSharp signature emitted by Outlook SafeLink / Office365 link
      // preview scanners crawling public share URLs — not reachable from app code.
      /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
    ],
  });
}

const store = StoreHandler.store;

store.dispatch(loadLocale());

//preload the loading spinner so it instantly shows when we actually need it. Especially relevant for slow networks.
const Preload = () => (
  <div style={{ display: "none" }}>
    <Spinner />
  </div>
);

const queryClient = new QueryClient();

export class AppProvider extends React.Component {
  render = () => (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={<LoadingView />} persistor={persistor}>
          <Environment>
            <BrowserRouter>
              <Fragment>
                <Preload />
                <NavigationBridge />
                <TopRoutes />
                {/* react-toastify 9 ships its defaults as defaultProps,
                    which React 19 ignores on function components — without
                    an explicit theme the toast gets theme--undefined and a
                    transparent background. Spell out the v9 defaults. */}
                <ToastContainer
                  transition={Slide}
                  limit={3}
                  position="top-right"
                  autoClose={5000}
                  theme="light"
                  closeOnClick
                  pauseOnHover
                  draggable
                />
              </Fragment>
            </BrowserRouter>
          </Environment>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}
